import { capitalize, upperCase } from 'lodash';
import { ASSET_TYPE } from './asset';
import { CHANNEL } from './channel';
import { ADS_CHANNELS, EMAILS_CHANNELS, RESOURCE_DOCUMENT, SOCIAL_CHANNELS } from './performance';

export const ERROR_BENCHMARK = 'Error detecting benchmark.';
export const NOT_ENOUGH_DATASET_ERROR = 'not_enough_dataset_error';
export const SYSTEM_ERROR = 'system_error';
export const BENCHMARK_CONFIG_ARCHIVED_ERROR = 'config_archived';

export const getChannelFromAssetType = (assetType) => {
  switch (assetType) {
    case ASSET_TYPE.facebookPrimaryText:
    case ASSET_TYPE.facebookHeadline:
    case ASSET_TYPE.facebookMixtureAd:
      return CHANNEL.facebook;
    case ASSET_TYPE.facebookPost:
      return CHANNEL.facebookPages;
    case ASSET_TYPE.googleDescription:
    case ASSET_TYPE.googleHeadline:
      return CHANNEL.google;
    case ASSET_TYPE.linkedinSingleImageHeadline:
    case ASSET_TYPE.linkedinSingleImageIntro:
    case ASSET_TYPE.linkedinMixtureAd:
      return CHANNEL.linkedin;
    case ASSET_TYPE.emailSubjectLine:
    case ASSET_TYPE.emailPromotionalBody:
    case ASSET_TYPE.emailPromotionalSubjectLine:
    case ASSET_TYPE.emailColdOutreachBody:
    case ASSET_TYPE.emailColdOutreachSubjectLine:
    case ASSET_TYPE.emailSubject:
    case ASSET_TYPE.emailBody:
      return CHANNEL.hubspot;
    case ASSET_TYPE.instagramCaption:
      return CHANNEL.instagram;
    default:
      return null;
  }
};

export const renderUserGoal = (value) =>
  value === 'ctr' ? upperCase(value).replaceAll('_', ' ') : capitalize(value).replaceAll('_', ' ');

export const getBenchmarkConfigFromGlobal = (globalBenchmarkConfig, assetType) => {
  const filtered = globalBenchmarkConfig?.filter((c) => c.assetType === assetType);

  return filtered?.[0];
};

export const SOURCE = {
  sharedPage: 'sharedPage',
  infinity: 'infinity',
  boost: 'boost',
};

export const getChannelItemLabel = (channel) =>
  SOCIAL_CHANNELS.includes(channel)
    ? 'account'
    : EMAILS_CHANNELS.includes(channel)
    ? 'email account'
    : ADS_CHANNELS
    ? 'ad account'
    : '';

export const getResourceChannelsFromAssetType = (assetType) => {
  switch (assetType) {
    case ASSET_TYPE.emailPromotionalBody:
      return [RESOURCE_DOCUMENT.emailPromotionCsvResource];
    case ASSET_TYPE.emailColdOutreachBody:
      return [RESOURCE_DOCUMENT.emailColdCsvResource];
    case ASSET_TYPE.emailSubject:
      return [
        RESOURCE_DOCUMENT.emailSubjectLineCsvResource,
        RESOURCE_DOCUMENT.emailPromotionCsvResource,
        RESOURCE_DOCUMENT.emailColdCsvResource,
      ];
    default:
      return [RESOURCE_DOCUMENT.emailCsvResource];
  }
};
